module.exports = __webpack_public_path__ + "static/media/ic_no_statistic.aaeebf06.svg";